export { c as createFlatProxy, a as createRecursiveProxy } from '../index-972002da.mjs';
